import angular from 'angular';
import cloneDeep from 'clone-deep';
import {load as loadControllers} from './controllers';

/* @ngInject */
export default function ($scope, LayoutService, $stateParams, toastr, DataTablesService, PermissionsCategories, PermissionsGates, PermissionsUsers, PreferencesService, PermissionsServiceUsers, DocumentsDirectories, DocumentsDocuments, DocumentsVersions, STATUSES, $state, moment, $uibModal, AuthService, $timeout, localStorageService, $q, DocumentsService) {
	loadControllers({
		$scope,
		LayoutService,
		$stateParams,
		toastr,
		DataTablesService,
		PermissionsCategories,
		PermissionsGates,
		PermissionsUsers,
		PermissionsServiceUsers,
		DocumentsDirectories,
		DocumentsDocuments,
		DocumentsVersions,
		STATUSES,
		$state,
		moment,
		$uibModal,
		AuthService,
		$timeout,
		localStorageService,
		$q,
		DocumentsService,
	});

	this.uiOnParamsChanged = (newParams) => {
		$scope.directoryId = newParams.directoryId;
	};

	LayoutService.reset();
	LayoutService.setTitle('Documents');

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'supportWorker.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'supportWorker.documents.root',
			             displayName: 'Documents',
		             },
	             ]);

	const indexDirectory = (directory, parentId) => {
		if (directory.children !== undefined && directory.documents !== undefined) {
			$scope.directoriesById[directory.id] = {
				...cloneDeep(directory),
				parent:    parentId,
				children:  directory.children.map((child) => {
					return child.id;
				}),
				documents: directory.documents.map((document) => {
					return document.id;
				}),
			};
		} else {
			// Potentially update just name?
		}
	};

	const indexDocument = (document, parentId) => {
		$scope.documentsById[document.id] = {
			...cloneDeep(document),
			parent: parentId,
		};
	};

	const recursivelyIndexDirectoriesById = (directories, parentId) => {
		angular.forEach(directories, (directory) => {
			indexDirectory(directory, parentId);

			angular.forEach(directory.documents, (document) => {
				indexDocument(document, directory.id);
			});

			recursivelyIndexDirectoriesById(directory.children, directory.id);
		});
	};

	$scope.directoriesById = {};
	$scope.documentsById   = {};

	$scope.indexEntitiesById = (directories) => {
		$scope.directoriesById = {};
		$scope.documentsById   = {};

		recursivelyIndexDirectoriesById(directories, null);
	};

	$scope.indexDirectoryById = (directory) => {
		const directories = [
			directory,
		];

		recursivelyIndexDirectoriesById(directories, directory.parent);
	};

	$scope.refreshDirectories();

	// $timeout(() => {
	// 	// Timeout to avoid saturating the server with requests
	// 	$scope.refreshPermissions();
	// }, 2500);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/documents/root/controller.js